export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_03-ceac173293156d53cb92d0c24e320fe2.jpg";